import React from 'react';
import './index.css';
import { useState } from 'react';
import $ from 'jquery';
import TextToSpeech from './txtTospeech.js';

export default function Quotes() {
  const [keyWordForSearch, setKeyWordForSearch] = useState('');
  const [results, setResults] = useState([]);
  const [keywords, setKeyWords] = useState([]);

  function handleOnChange(e) {
    $.ajax({
      url: 'https://zenquotes.io/api/keywords/95d53ad7e5dc6181af38b4fa1d35407a20eeb99a',
      dataType: 'json',
      success: function (keywords) {
        setKeyWords(keywords);
      },
      error: function () {
        alert('AJAX Error.');
      },
    });

    if (e.target.name == 'searchTerm') {
      setKeyWordForSearch(e.target.value);
    }
  }

  function handleOnSubmit(e) {
    e.preventDefault();
    console.log(keywords);
    if (keyWordForSearch) {
      var validKeyWord = false;
      for (var i = 0; i < keywords.length; i++) {
        if (keywords[i].k == keyWordForSearch) {
          validKeyWord = true;
        }
      }
      if (validKeyWord == true) {
        console.log('A valid keyword was entered');
        document.querySelector('thead').style.color = '#535307';
        document.querySelector('thead').style.color = '#535307';

        $.ajax({
          url:
            'https://zenquotes.io/api/quotes/95d53ad7e5dc6181af38b4fa1d35407a20eeb99a&keyword=' +
            keyWordForSearch,
          dataType: 'json',
          success: function (data) {
            setResults(data);
          },
          error: function () {
            alert('AJAX Error.');
          },
        });
      } else {
        console.log('INVALID KEYWORD ENTERED');
        var keywordsprint = [];
        for (var i = 0; i < keywords.length; i++) {
          keywordsprint.push(' ' + keywords[i].k);
        }

        alert(
          'Not a valid keyword. Choose from the following:\n' + keywordsprint
        );
      }
    } else {
      alert('Please enter a search term');
    }
  }
  return (
    <div className="contact">
      <form id="quoteForm" onSubmit={handleOnSubmit}>
        Input a keyword:
        <input
          type="text"
          id="search-term"
          placeholder="anxiety"
          name="searchTerm"
          value={keyWordForSearch.toLowerCase()}
          onChange={handleOnChange}
        />
        <button type="submit">Search</button>
        <table>
          <thead>
            <tr>
              <th>Author</th>
              <th>Quote</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {results.map((item) => (
              <tr>
                <td>
                  <img src={item.i}></img>
                  <p className="tablep">{item.a}</p>
                </td>
                <td>{item.q}</td>
                <td>
                  <TextToSpeech inputText={item.q + '      ' + item.a}></TextToSpeech>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </form>
    </div>
  );
}
